var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconHubStartApp3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 26,
    height: 32,
    viewBox: "0 0 26 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M27.89 16.28L16.61 9.77a1.86 1.86 0 0 0-2.79 1.62v13A1.86 1.86 0 0 0 16.61 26l11.28-6.51a1.87 1.87 0 0 0 0-3.23v.02zm-12.07 7.89V11.62l10.87 6.28-10.87 6.27zM26.54 26a1 1 0 0 0-1 1v1.37A1.67 1.67 0 0 1 23.89 30H6.87a1.68 1.68 0 0 1-1.7-1.65V8.16h4.4a1.89 1.89 0 0 0 1.9-1.88V2H24a1.67 1.67 0 0 1 1.69 1.64v7a1 1 0 0 0 2 0v-7A3.67 3.67 0 0 0 24 0H10.4a1 1 0 0 0-.24.05h-.1a1.07 1.07 0 0 0-.28.19L7.15 2.85l-3.67 3.6a1 1 0 0 0-.3.8v21.09A3.68 3.68 0 0 0 6.88 32H23.87a3.67 3.67 0 0 0 3.65-3.69V27a1 1 0 0 0-.98-1zM6.68 6.16L8.1 4.72l1.37-1.35v2.79H6.68z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(-3)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    fillRule: "nonzero",
    xlinkHref: "#a"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h32v32H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconHubStartApp3);
export default __webpack_public_path__ + "static/media/icon-hub-start-app-3.3184e524484841d57044e4de0ff895d1.svg";
export { ForwardRef as ReactComponent };